const menuItems = {
  items: [
    {
      id: 'pages',
      title: 'Pages',
      type: 'group',
      icon: 'icon-pages',
      children: [
        {
          id: 'user-management',
          title: 'User Management',
          icon: 'feather icon-user',
          type: 'collapse',
          children: [
            {
              id: 'user',
              title: 'User',
              type: 'item',
              url: '/'
            }
          ]
        },
        {
          id: 'product-management',
          title: 'Product Management',
          icon: 'feather icon-command',
          type: 'collapse',
          children: [
            {
              id: 'metal',
              title: 'Metal',
              type: 'item',
              url: '/metal'
            },
            {
              id: 'product-shape',
              title: 'Product Shape',
              type: 'item',
              url: '/product-shape'
            },
            {
              id: 'category',
              title: 'Category',
              type: 'item',
              url: '/category'
            },
            {
              id: 'category-style',
              title: 'Category Style',
              type: 'item',
              url: '/category-style'
            },
            {
              id: 'product-details',
              title: 'Product Details',
              type: 'item',
              url: '/product-details'
            },
            {
              id: 'carat-product',
              title: 'Product Carat',
              type: 'item',
              url: '/product-carat'
            },
            {
              id: 'product-ad-banner',
              title: 'Product Ad Banner',
              type: 'item',
              url: '/product-ad-banner'
            }
          ]
        },
        {
          id: 'customer-management',
          title: 'Customer Management',
          icon: 'feather icon-users',
          type: 'collapse',
          children: [
            // {
            //   id: 'wish',
            //   title: 'Wish',
            //   type: 'item',
            //   url: '/wish'
            // },
            {
              id: 'product-review',
              title: 'Product Review',
              type: 'item',
              url: '/product-review'
            },
            {
              id: 'customer-review',
              title: 'Customer Review',
              type: 'item',
              url: '/customer-review'
            }
          ]
        },
        {
          id: 'pages-management',
          title: 'Pages Management',
          icon: 'feather icon-layout',
          type: 'collapse',
          children: [
            {
              id: 'page-name',
              title: 'Page Name',
              type: 'item',
              url: '/page-name'
            },
            {
              id: 'page-banner',
              title: 'Page Banner',
              type: 'item',
              url: '/page-banner'
            },
            {
              id: 'footer',
              title: 'Footer',
              type: 'item',
              url: '/footer'
            }
          ]
        },
        {
          id: 'content-management',
          title: 'Content Management',
          icon: 'feather icon-package',
          type: 'collapse',
          children: [
            {
              id: 'faqs',
              title: 'FAQs',
              type: 'item',
              url: '/faqs'
            },
            {
              id: 'blogs',
              title: 'Blogs',
              type: 'item',
              url: '/blogs'
            }
          ]
        },
        {
          id: 'user-queries',
          title: 'User Queries',
          icon: 'feather icon-help-circle',
          type: 'collapse',
          children: [
            {
              id: 'user-shape',
              title: 'User Shape',
              type: 'item',
              url: '/user-shape'
            },
            {
              id: 'engrave',
              title: 'Engrave',
              type: 'item',
              url: '/engrave'
            }
          ]
        },
        {
          id: 'drop-mail',
          title: 'Drop Mail',
          icon: 'feather icon-inbox',
          type: 'collapse',
          children: [
            {
              id: 'dropMail',
              title: 'Drop Mail',
              type: 'item',
              url: '/drop-mail'
            },
          ]
        },
        {
          id: 'contact-us',
          title: 'Contact Us',
          icon: 'feather icon-inbox',
          type: 'collapse',
          children: [
            {
              id: 'contact',
              title: 'Contact us Query',
              type: 'item',
              url: '/contact-us'
            },
          ]
        },
      ]
    }
  ]
};

export default menuItems;
